<template>
    <div class="pdf-viewer">
        <PDFData
            class="pdf-viewer__main"
            :url="url"
            @page-count="updatePageCount"
            @page-focus="updateCurrentPage"
            @document-rendered="onDocumentRendered"
            @document-errored="onDocumentErrored"
        >
            <PDFPreview
                class="pdf-viewer__preview"
                slot="preview"
                slot-scope="{pages}"
                v-bind="{pages, scale, currentPage, pageCount}"
            />

            <PDFDocument
                class="pdf-viewer__document"
                slot="document"
                slot-scope="{pages}"
                v-bind="{pages, scale, currentPage, pageCount}"
                @scale-change="updateScale"
            />

            <PDFToolbar
                slot="toolbar"
                slot-scope="{pages}"
                :class="{ 'mb-8': hasFunnel}"
                v-bind="{pages, url}"
            />
        </PDFData>
    </div>
</template>

<script>
    import PDFDocument from './PDFDocument';
    import PDFPreview from './PDFPreview';
    import PDFData from './PDFData';
    import PDFToolbar from './PDFToolbar';

    export default {
        name: 'PDFViewer',
        components: {
            PDFDocument,
            PDFPreview,
            PDFData,
            PDFToolbar
        },
        props: {
            url: String,
            hasFunnel: Boolean
        },
        data() {
            return {
                scale: undefined,
                currentPage: 1,
                pageCount: undefined,
            };
        },
        mounted() {
            document.body.classList.add('overflow-hidden');
        },
        methods: {
            onDocumentRendered() {
                this.$emit('document-errored', this.url);
            },
            onDocumentErrored(e) {
                this.$emit('document-errored', e);
            },
            updateScale(scale) {
                this.scale = this.floorScale(scale, 2);
            },
            updatePageCount(pageCount) {
                this.pageCount = pageCount;
            },
            updateCurrentPage(pageNumber) {
                this.currentPage = pageNumber;
            },
            floorScale(value, precision) {
                const multiplier = Math.pow(10, precision || 0);
                return Math.floor(value * multiplier) / multiplier;
            }
        },
        watch: {
            url() {
                this.currentPage = 1;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .widget {
        .pdf-viewer__preview {
            width: 15%;
            right: 85%;
        }
        .pdf-viewer__document {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFViewer.vue